






























































import Vue from 'vue';
import {DateTimeFormats} from "@/components/properties/settings/export/model/DateTimeFormats";
import ExportLayout from "@/components/properties/settings/export/model/ExportLayout";
import {AXIOS} from "@/lib/http-common";
import UserActionResultSender from "@/components/application/UserActionResultSender";
import draggable from 'vuedraggable';
import {i18n} from "@/main";

interface PrefixConfig {
  id: number;
  type: string;
  staticValue: string;
  format?: string;
}

interface PrefixConstant {
  text: string;
  value: string;
}

export default Vue.extend({
  name: 'PatternBuilder',
  props: {
    initialPattern: {
      type: String,
      default: ''
    },
    exportTypeFileShort: String,
    frequency: String
  },
  components: {
    draggable
  },
  computed: {
    DateTimeFormats() {
      return DateTimeFormats;
    }
  },
  data() {
    return {
      prefixes: [] as PrefixConfig[],
      separator: '_',
      separatorOptions: [
        {text: i18n.tc('export.autoExport.fileNamePattern.underscore'), value: '_'},//'Underscore (_)'
        {text: i18n.tc('export.autoExport.fileNamePattern.dash'), value: '-'},//'Dash (-)',
        {text: i18n.tc('export.autoExport.fileNamePattern.period'), value: '.'},//'Period (.)'
        {text: i18n.tc('export.autoExport.fileNamePattern.space'), value: ' '},//'Space'
      ] as SeparatorOption[],
      customSeparator: false,
      staticValue: '',
      prefixesConstants: [
        {text: i18n.tc('export.autoExport.fileNamePattern.date'), value: 'date'},//'Date'
        {text: i18n.tc('export.autoExport.fileNamePattern.static'), value: 'static'}//'Static Text'
      ] as PrefixConstant[],
      availablePrefixes: [] as PrefixConstant[],
      exportLayoutFromDatabase: [] as ExportLayout[],
      loading: false,
      nextId: 0,
      errorMessage: '',
    };
  },
  mounted() {
    this.getExportLayoutFromDatabase();
    console.log(this.initialPattern);
  },
  watch: {
    exportTypeFileShort(newType: string) {
      this.generatePattern(newType);
    },
    frequency(newFrequency: string) {
      this.getExportLayoutFromDatabase();
    }
  },
  methods: {
    addPrefix() {
      // this.getExportLayoutFromDatabase();
      const newPrefix = {id: this.nextId++, type: '', staticValue: ''};
      this.prefixes.push(newPrefix);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    removePrefix(prefixToRemove: PrefixConfig) {
      this.prefixes = this.prefixes.filter(prefix => prefix.id !== prefixToRemove.id);
    },
    generatePattern(type: string) {
      const parts = this.prefixes.map((prefix) => {
        switch (prefix.type) {
          case 'date':
            return `<${prefix.format || 'yyyy-MM-dd'}>`;
          case 'static':
            return `<${prefix.staticValue || '<custom>'}>`;
          default:
            return '<' + prefix.type + '>';
        }
      });

      const pattern = parts.filter(Boolean).join(this.separator) + '.' + (type != null && type != '' ? type : this.exportTypeFileShort);
      this.$emit('update', pattern);
    },
    getExportLayoutFromDatabase() {
      this.loading = true;
      AXIOS.get('/export-layout/')
        .then((message) => {
          this.exportLayoutFromDatabase = message.data;
          let newOptions;
          if (this.frequency === 'afterUpdate') {
            newOptions = this.exportLayoutFromDatabase.map((layout) => {
              return {
                text: layout.customFieldName || layout.cubiscanFieldName,
                value: layout.cubiscanFieldName
              };
            });
          } else {
            newOptions = [{
              text: i18n.tc('export.autoExport.fileNamePattern.dateRange'),//"Date range",
              value: "dateRange"
            }];
          }
          this.availablePrefixes = [];
          this.prefixesConstants.forEach(value => {
            this.availablePrefixes.push({
              text: value.text,
              value: value.value
            });
          });
          const existingValues = new Set(this.availablePrefixes.map(p => p.value));
          newOptions.forEach(option => {
            if (!existingValues.has(option.value)) {
              this.availablePrefixes.push(option);
            }
          });
        })
        .catch(error => {
          UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
        })
        .finally(() => {
          this.parseInitialPattern();
          this.loading = false;
        });
    },
    setSeparator(val: string) {
      const restrictedChars = /[\\/?:*|<>]/;
      let enteredSeparator;
      if (typeof val === 'object' && val !== null && 'value' in val) {
        enteredSeparator = (val as { value: string }).value;
      } else {
        enteredSeparator = val;
      }

      if (restrictedChars.test(enteredSeparator)) {
        this.separator = enteredSeparator.replace(restrictedChars, '');
        this.errorMessage = i18n.tc('export.autoExport.fileNamePattern.invalidCharactersDetected');
      } else if (!enteredSeparator) {
        this.errorMessage = i18n.tc('export.autoExport.fileNamePattern.separatorCannotBeEmpty');
      } else {
        this.errorMessage = '';
        this.separator = enteredSeparator;
      }
    },
    validateSeparator(val: string) {
      const restrictedChars = /[\\/?:*|<>]/;
      let char = (typeof val === 'object' && val !== null && 'value' in val) ? (val as { value: string }).value : val;
      if (restrictedChars.test(char)) {
        char = char.replace(restrictedChars, '');
        this.errorMessage = i18n.tc('export.autoExport.fileNamePattern.invalidCharactersDetected');//'Invalid characters detected ( / \\ ? % * | : < > )'
      } else if (!char) {
        this.errorMessage = i18n.tc('export.autoExport.fileNamePattern.separatorCannotBeEmpty');//'Separator cannot be empty or contain only invalid characters'
      } else {
        this.errorMessage = '';
      }
      this.separator = char;
    },
    isDynamicField(value: string) {
      return this.exportLayoutFromDatabase.some(layout => (layout.cubiscanFieldName === value || layout.customFieldName === value));
    },

    parseInitialPattern() {
      if (!this.initialPattern) {
        return;
      }

      const patternWithoutExtension = this.initialPattern.replace(/\.[^/.]+$/, '');

      // Match all <...> tokens and also remember what's between them (separator detection)
      const tokenAndSeparatorRegex = /<[^>]*>|[^<]+/g;
      const partsWithSeparators = patternWithoutExtension.match(tokenAndSeparatorRegex) || [];

      const tokens: string[] = [];
      const separators: string[] = [];

      for (let i = 0; i < partsWithSeparators.length; i++) {
        const part = partsWithSeparators[i].trim();

        if (part.startsWith('<') && part.endsWith('>')) {
          tokens.push(part);
        } else if (part.length > 0) {
          separators.push(part);
        }
      }

      // Determine the separator used (we assume one consistent separator)
      this.separator = separators.length > 0 ? separators[0].trim() : '_';

      this.prefixes = tokens.map(part => {
        const inner = part.slice(1, -1).trim();

        if ((this.DateTimeFormats as any)[inner] || Object.values(this.DateTimeFormats as any).includes(inner)) {
          return {
            id: this.nextId++,
            type: 'date',
            staticValue: '',
            format: inner
          };
        } else if (this.isDynamicField(inner)) {
          return {
            id: this.nextId++,
            type: inner,
            staticValue: ''
          };
        } else {
          return {
            id: this.nextId++,
            type: 'static',
            staticValue: inner
          };
        }
      });
    }
    ,

    escapeRegex(str: string) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }


  }
})
;
